export interface AsOfDate {
  year: string;
  quarter: string;
  current?: boolean;
}
export const ExcludedSegments = ["Global Credit", "Real Assets", "Corporate", "Carlyle AlpInvest"];

export const ExcludedFundFamilies = [
  "Asia Real Estate",
  "Europe Real Estate",
  "Latin America Real Estate",
  "Real Estate Credit",
  "Realty Credit",
  "US Real Estate",
  "Life Sciences",
  "Insurance",
  "Managed Accounts",
];
